import React from "react";
import { Route } from "react-router-dom";
import Homepage from "../pages/static-pages/homepage";
import AboutPage from "../pages/static-pages/aboutpage";
import ContactPage from "../pages/static-pages/contact-page";
import BuyMeterPage from "../pages/static-pages/buy-meter-page";
import DownloadPage from "../pages/static-pages/DownloadPage";

export default function GetStaticRoutes() {
  return (
    <React.Fragment>
      <Route path="/">
        <Route index element={<Homepage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="buy-meter" element={<BuyMeterPage />} />
        <Route path="download" element={<DownloadPage />} />
      </Route>
    </React.Fragment>
  );
}
